import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { AdminContentItemService } from '@/modules/content-item/services/admin-content-item.service'
import { ContentItemSendToCompletedRequestModel } from '@/modules/content-item/models/content-item-request.model'
import { vservice } from '@niknevis/vue-modules'

@vservice()
export class AdminContentItemSendToCompletedUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: AdminContentItemService
  ) {
  }

  isLoading = false
  isSuccess = false

  execute(itemId: number, data: Omit<ContentItemSendToCompletedRequestModel, 'status'>) {
    return this.service.sendToCompleted(itemId, data)
      .onStart(() => {
        this.isLoading = true
        this.isSuccess = false
      })
      .onFinish(() => {
        this.isLoading = false
      })
      .onSuccess(() => {
        this.isSuccess = true
      })
  }
}